import React, {useRef, useState} from "react";
import UserCard from "./userCard";
import userApi from "../../api/usersAPI";
import InvitationsApi from "../../api/invitationsAPI";
import CareerMatches from "./careerMatches";
import StatementResults from "./statementResults";
import AptitudeResult from "./aptitudeResult";
import PopUp from "../../base/popup";
import HoverButton from "../../buttons/HoverButton";
import ResendPopup from "../resendPopup";
import {Loader} from "react-fields";


export default function UserShow(props) {

    const [user, setUser] = useState(props.user);
    const sentInvitationsRef = useRef(null);
    const moreRetakesRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);

    const educator = props.educator;

    const completedProfile = () => {
        let statuses = [user.interests_status,user.personality_status,user.motivators_status,user.abstract_status,
            user.numerical_status,user.verbal_status];
        return !statuses.includes('not_started') && !statuses.includes('started');
    };

    const deleteUser = () => {
        userApi.deleteUser(user.id).then((response) => {
            document.location.href = '/group/users';
        }).catch(error => {
            console.log(error);
        });
    };

    const resendInvitation = () => {
        setIsLoading(true);
        InvitationsApi.resend(user.id).then((response) => {
            sentInvitationsRef.current.open();
            setIsLoading(false)
        }).catch(error => {
            console.log(error);
            setIsLoading(false)
        });
    };


    const resetUserTest = (testId, callbackFunc) => {
        userApi.resetUserTest(user.id, testId).then((response) => {
            setUser({...user,...response});
            callbackFunc()
       }).catch(error => {
            console.log(error);
            error.json().then(function (value) {
                if(value.error_code === 'limit_reached') {
                    moreRetakesRef.current.open();
                }
            });
        });
    };

    const addMoreRetakes = () => {
        userApi.addMoreRetakes(user.id).then((response) => {
            setUser({...user,...response});
            moreRetakesRef.current.close();
        }).catch(error => {
            console.log(error);
        });
    };


    return (
        <div className="grid-container transparent">
            <div className="grid-x">
                {isLoading ? <Loader /> : null}
                <div className="small-12 cell"><h1 className="user__name"><span>User</span> <span
                    className="small-icon arrow"/>{props.user.name}</h1></div>
                   <UserCard user={user} completed={completedProfile()}
                             deleteUser={deleteUser}
                             resendInvitation={resendInvitation} />
                <CareerMatches user={user} completed={completedProfile()} career_matches={props.career_matches} isAvailable={educator.full_access} />
                <StatementResults parentClass={"large-offset-3 large-3 medium-6 small-12 cell"}
                                     finished={user.interests_status === 'finished'}
                                     results={props.statement_results.interests}
                                     finished_at={user.interests_finished_at}
                                     retakes={'unlimited'}
                                     temp={user.temp}
                                     reset={resetUserTest}
                                     testId={1} testCode={'interests'} userId={user.id}
                                     isAvailable={educator.full_access || educator.interests_access}
                                     name={"Career Interests"}/>
                <StatementResults parentClass={"large-3 medium-6 small-12 cell"}
                                  finished={user.personality_status === 'finished'}
                                  finished_at={user.personality_finished_at}
                                  retakes={user.personality_retakes}
                                  reset={resetUserTest}
                                  temp={user.temp}
                                  testId={2} testCode={'personality'} userId={user.id}
                                  results={props.statement_results.personality}
                                  isAvailable={educator.full_access || educator.personality_access}
                                  name={"Work Personality"}/>
                <StatementResults parentClass={"large-3 medium-6 small-12 cell"}
                                  finished={user.motivators_status === 'finished'}
                                  finished_at={user.motivators_finished_at}
                                  results={props.statement_results.motivators}
                                  retakes={user.motivators_retakes}
                                  reset={resetUserTest}
                                  temp={user.temp}
                                  testId={3} testCode={'motivators'} userId={user.id}
                                  isAvailable={educator.full_access || educator.motivators_access}
                                  name={"Career Motivators"}/>
                <AptitudeResult parentClass={"large-offset-3 large-3 medium-6 small-12 cell"}
                                result={props.aptitude_results.abstract}
                                reset={resetUserTest}
                                testId={4} testCode={'abstract'} userId={user.id}
                                temp={user.temp}
                                finished_at={user.abstract_finished_at}
                                name={"Abstract Reasoning"}
                                retakes={user.abstract_retakes}
                                isAvailable={educator.full_access || educator.abstract_access}
                                finished={user.abstract_status === 'finished'} />
               <AptitudeResult parentClass={"large-3 medium-6 small-12 cell"}
                                result={props.aptitude_results.verbal}
                                name={"Verbal Reasoning"}
                                testId={6} testCode={'verbal'} userId={user.id}
                                temp={user.temp}
                                retakes={user.verbal_retakes}
                                finished_at={user.verbal_finished_at}
                                reset={resetUserTest}
                                isAvailable={educator.full_access || educator.verbal_access}
                                finished={user.verbal_status === 'finished'} />
                <AptitudeResult parentClass={"large-3 medium-6 small-12 cell"}
                                result={props.aptitude_results.numerical}
                                name={"Numerical Reasoning"}
                                testId={5} testCode={'numerical'} userId={user.id}
                                temp={user.temp}
                                retakes={user.numerical_retakes}
                                finished_at={user.numerical_finished_at}
                                reset={resetUserTest}
                                isAvailable={educator.full_access || educator.numerical_access}
                                finished={user.numerical_status === 'finished'} />

                <PopUp ref={moreRetakesRef}>
                    <div className="grid-x align-center">
                        <div className="cell text-center">
                            <h3 className='text-center mar-bot-10'> Retake limit reached!</h3>
                            {props.educator.available_licenses <= 0 ?
                                <React.Fragment>
                                    <p className='popup__text'>
                                        You have used all 3 retakes for the user {user.name}. You can use an additional license to enable this user 3 more retakes on all tests.
                                    </p>
                                    <HoverButton onClick={()=>{document.location.href='/group'}}>Purchase Licenses</HoverButton>
                                </React.Fragment> :
                                <React.Fragment>
                                    <p className='popup__text'>
                                        You have used all 3 retakes for the user {user.name}. You can use an additional license to enable this user 3 more retakes on all tests.
                                    </p>
                                    <HoverButton onClick={addMoreRetakes}>Use 1 license</HoverButton>
                                </React.Fragment>
                            }

                        </div>
                    </div>
                </PopUp>
                <PopUp ref={sentInvitationsRef} onClose={() => {}}>
                    <ResendPopup email={user.email}/>
                </PopUp>

            </div>
        </div>


    )
}